require('./bootstrap');
// import './bootstrap';

// Bootstrap Date Range Picker

import daterangepicker from 'bootstrap-daterangepicker';
window.daterangepicker = daterangepicker;

// Bootstrap Table

window.bootstrap = {
    Tooltip: {
        VERSION: "5"
    }
}

import('bootstrap-table');

// Chart.js

window.Chart = require('chart.js/auto');

// Chosen
import('chosen-js');

// Flatpickr

// import flatpickr from 'flatpickr';
// window.flatpickr = flatpickr;
window.flatpickr = require('flatpickr');
import * as LightweightCharts from 'lightweight-charts';
window.LightweightCharts = LightweightCharts;

// jQuery - Date Time Picker
import('jquery-datetimepicker');

// jQuery UI - autocomplete
import 'jquery-ui/ui/widgets/autocomplete.js';

// jQuery UI - sortable
import 'jquery-ui/ui/widgets/sortable.js';

// Moment.js

import moment from 'moment';
window.moment = moment;

// NProgress

import nprogress from 'nprogress';
window.NProgress = nprogress;

// Sprintf-js
window.sprintf = require('sprintf-js').sprintf;
window.vsprintf = require('sprintf-js').vsprintf;

// SweetAlert2

import sweetalert2 from 'sweetalert2';
window.Swal = sweetalert2;

// App

require('./app/actions.js');
require('./app/chosen.js');
require('./app/colorCellStyle.js');
require('./app/datepicker.js');
require('./app/daterangepicker.js');
require('./app/font_awesome.js');
require('./app/i18n.js');
require('./app/nbrogress.js');
// require('./app/online.js');
// require('./app/password.js');
// require('./app/ready.js');
require('./app/sidebar.js');
require('./app/tables.js');
require('./app/tabs.js');
require('./app/tooltip.js');
require('./app/validation.js');

// Formatters

require('./app/formatters/color.js');
require('./app/formatters/active.js');
require('./app/formatters/amountFooter.js');
require('./app/formatters/avatar.js');
require('./app/formatters/badge/method.js');
require('./app/formatters/boolean.js');
require('./app/formatters/code.js');
require('./app/formatters/country/icon.js');
require('./app/formatters/delete.js');
require('./app/formatters/duplicate.js');
require('./app/formatters/edit.js');
require('./app/formatters/email.js');
require('./app/formatters/fontAwesome.js');
require('./app/formatters/phone.js');
require('./app/formatters/rowStyle.js');
require('./app/formatters/show.js');
require('./app/formatters/sortable.js');
require('./app/formatters/tags.js');
require('./app/formatters/url.js');
require('./content/apis/coinbase/requestDetailFormatter.js');

// Functions

require('./app/functions/number_format_to_decimal.js');
require('./app/functions/number_format.js');
